<article *ngIf="article"
         class="data-view-layout">

  <div class="menu-wrap">
    <div class="close-btn"
         (click)="onClose($event)">
      <div class="close-icon"></div>
    </div>
  </div>

  <div *ngIf="is_loading; else articleLoaded"
       class="loading-box">

    <img src="assets/img/loading_icon.gif">
  </div>

  <ng-template #articleLoaded>
    <div class="view-group-box">
      <div *ngIf="article.thumbnail" class="view-img-box">
        <img src="{{ article.thumbnail }}" alt="이미지" />
      </div>
      <div class="view-info-box">
        <div class="view-subject-box"
             [innerHTML]="article.title | resize"></div>
        <div class="view-con-box" [innerHTML]="ApiUrlReplace(article.content) | keepHtml"></div>
      </div>
    </div>

    <!-- div class="view-menu-box">
      <a class="view-menu-btn" (click)="onClose($event)">닫기</a>
    </div -->

  </ng-template>



</article>
